import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import { CompareProvider } from "./context/CompareContext";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Compare from "./pages/Compare";
import Calculator from "./pages/Calculator";
import MortgageCalculator from "./pages/MortgageCalculator";
import Admin from "./pages/Admin";
import ProviderPortal from "./pages/ProviderPortal";

const ShellRoutes = () => {
    const location = useLocation();
    // Portal is standalone — no main shell/nav
    const isPortal = location.pathname.startsWith("/portal/");

    if (isPortal) {
        return (
            <Routes>
                <Route path="/portal/:token" element={<ProviderPortal />} />
            </Routes>
        );
    }

    return (
        <Layout>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:id" element={<ProductDetail />} />
                <Route path="/loans" element={<Navigate to="/products?type=loan" replace />} />
                <Route path="/credit-cards" element={<Navigate to="/products?type=credit_card" replace />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/calculator" element={<Calculator />} />
                <Route path="/mortgage-calculator" element={<MortgageCalculator />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Layout>
    );
};

function App() {
    return (
        <div className="App">
            <CompareProvider>
                <BrowserRouter>
                    <ShellRoutes />
                </BrowserRouter>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "#0B192C",
                            color: "#F8F7F4",
                            border: "1px solid rgba(248,247,244,0.2)",
                            borderRadius: 0,
                            fontFamily: "IBM Plex Mono, monospace",
                            fontSize: "13px",
                        },
                    }}
                />
            </CompareProvider>
        </div>
    );
}

export default App;
